var heroInterstellar = {};
var heroInterstellarSlider = $('.js-hero-banner-interstellar-slider');
heroInterstellar.slider = function () {
  if (heroInterstellarSlider.length === 0) {
    return;
  }
  $.each(heroInterstellarSlider, function () {
    var $slider = $(this);
    var autoPlayValue = $slider.data('autoplay');
    var sliderLength = $slider.find('.section-hero-banner-interstellar').length;
    if (sliderLength > 1) {
      $slider.flickity({
        cellAlign: 'left',
        autoPlay: autoPlayValue,
        contain: true,
        wrapAround: true,
        prevNextButtons: sliderLength > 1 ? true : false,
        draggable: sliderLength > 1 ? true : false,
        pageDots: sliderLength > 1 ? true : false,
        dragThreshold: 10,
        on: {
          ready: function ready() {
            $slider.removeClass('invisible');
          }
        }
      });
    } else {
      $slider.removeClass('invisible');
    }
  });
};
heroInterstellar.slider();
window.heroInterstellar = heroInterstellar;


// WEBPACK FOOTER //
// ./scripts/components/sliders/interstellar/hero.js